import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState }  from '../../store';
import * as AuthenticationState from '../../store/authentication';

// At runtime, Redux will merge together...
type LogoutProps =
    AuthenticationState.AuthenticationState         // ... state we've requested from the Redux store
    & typeof AuthenticationState.actionCreators     // ... plus action creators we've requested
    & RouteComponentProps<{ }>;                     // ... plus incoming routing parameters

class Logout extends React.Component<LogoutProps> {

    public componentWillMount() {
        this.props.clearUserToken();
        setTimeout(() => {
            this.props.history.push("/home");
        }, 1000);
    }

    public render() {
        return (
            <p>Redirecting...</p>
        );
    }
}

export default withRouter(connect(
    (state: ApplicationState) => state.authentication, // Selects which state properties are merged into the component's props
    AuthenticationState.actionCreators                 // Selects which action creators are merged into the component's props
)(Logout));
